import { BooleanParam, useQueryParam } from 'use-query-params'

export const useShowOutletPreviewParam = () =>
  useQueryParam('outletPreview', BooleanParam)
